export default __webpack_public_path__ + "static/media/gifts-banner.581689c3.webp";